
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeTaskGrid extends Serenity.EntityGrid<UtentiProdottiEsperienzeTaskRow, any> {
        protected getColumnsKey() { return UtentiProdottiEsperienzeTaskColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiEsperienzeTaskDialog; }
        protected getIdProperty() { return UtentiProdottiEsperienzeTaskRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeTaskRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeTaskRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeTaskService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}